import { withErrorBoundary } from 'app/components/error-boundary';
import { withDashboardLayout } from 'app/hooks/with-dashboard-layout';
import type { NavigationScreen } from 'app/types/navigation';
import { withOptionalMetrics } from 'app/utils/performance/with-metrics';
import { AllNotificationsScreenComponent } from './all-notifications-screen-component';
import { NotificationsOverlayScreenComponent } from './notifications-overlay-screen-component';
export const AllNotificationsScreen: NavigationScreen<'all-notifications'> = withOptionalMetrics(
  'AllNotificationsScreen',
  withErrorBoundary(withDashboardLayout(AllNotificationsScreenComponent, 'simpleVerticalScrolling', true)),
);

export const NotificationsOverlayScreen: NavigationScreen<'notificationsOverlay'> = withOptionalMetrics(
  'NotificationsOverlayScreen',
  withErrorBoundary(NotificationsOverlayScreenComponent),
);
